import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from '../../helpers/api_helper';
import Log from '../../Services/Log';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';

export const getDashboard = createAsyncThunk(
    'dashboard/get',
    async (status = 'active', thunkAPI) => {
        try {
            const response = await api.get(API_ENDPOINTS.DASHBOARD.GET);
            // Log('dashboard data' , 'info' , response.data)
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }

);